import {createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';

import { RootReducer } from './RootReducer';


export const ConfigureStore = () => {
    console.log("*******    Configure Store **********");
    const store = createStore(
        RootReducer,
        applyMiddleware(thunk, logger)
    );

    return store;
}
